function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 196,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "m181 296h150c5.522 0 10-4.477 10-10v-93.972l13.493 11.566c4.21 3.609 10.521 3.09 14.1-1.086 3.594-4.193 3.108-10.506-1.086-14.101l-104.999-89.999c-3.744-3.21-9.271-3.21-13.016 0l-104.999 89.999c-4.194 3.594-4.68 9.907-1.086 14.101 3.593 4.194 9.907 4.679 14.1 1.086l13.493-11.566v93.972c0 5.523 4.478 10 10 10zm10-121.115 65-55.714 65 55.714v101.115h-55v-40c0-5.523-4.478-10-10-10s-10 4.477-10 10v40h-55z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m248.814 508.954c1.884 1.947 4.477 3.046 7.186 3.046s5.302-1.099 7.186-3.046c63.824-65.879 182.814-214.083 182.814-312.954 0-34.896-9.487-69.49-27.438-100.042-2.799-4.762-8.926-6.354-13.688-3.557-4.762 2.798-6.354 8.926-3.557 13.688 16.148 27.484 24.683 58.575 24.683 89.911 0 101.169-136.787 255.428-170 291.384-33.213-35.956-170-190.215-170-291.384 0-95.402 77.851-176 170-176 30.377 0 60.33 8.741 86.62 25.279 4.673 2.941 10.849 1.535 13.789-3.14s1.534-10.849-3.141-13.789c-29.483-18.547-63.118-28.35-97.268-28.35-106.552 0-190 92.76-190 196 0 98.768 118.792 246.87 182.814 312.954z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 383,
  cy: 65,
  r: 10
}));

var SvgNavigate = function SvgNavigate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    width: 35,
    height: 35,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavigate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/navigate.ad0e8c8f.svg";
export { ForwardRef as ReactComponent };